import KDSideMenu from './kd-sidemenu.vue';
export default KDSideMenu;



//////////////////
// WEBPACK FOOTER
// ./components/kd-sidemenu/index.js
// module id = null
// module chunks = 